import { styled, Alert, Typography, keyframes, Skeleton } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import VoucherState from 'components/VoucherState';
import LogPattern from 'assets/images/graphic-surprise-perk-flash.png';
import MissingImage from 'components/MissingImage';

const surprisePerkTextColor = theme.palette.white;

const animateLog = keyframes`
  from, to {
    filter: brightness(100%);
    transform: scale(1);
  }
  50% {
    filter: brightness(150%);
    transform: scale(1.1);
  }
`;

const animationSettings = '3s cubic-bezier(.77,0,.18,1) 0s infinite';

export const Wrapper = styled('div')``;

export const MediaWrap = styled('div')`
  position: relative;
`;

export const SurprisePerkFlash = styled('div')`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 1.4rem 1rem 1rem;
  z-index: 1;
  background: url(${LogPattern}) top left no-repeat;
  background-size: cover;
  animation: ${animateLog} ${animationSettings};
  transform-origin: bottom left;

  .MuiTypography-root {
    margin: 0;
    color: ${surprisePerkTextColor};
    font-size: 24px;
  }
`;

export const SurprisePerkTitle = styled(Typography)`
  margin-left: 8px !important;
`;

export const StyledMissingImage = styled(MissingImage)`
  min-height: 180px;

  ${theme.breakpoints.up('md')} {
    min-height: 260px;
  }
`;

export const StyledVoucherState = styled(VoucherState)``;

export const StyledAlert = styled(Alert)`
  margin-bottom: 1rem;
  width: 100%;
`;

export const Footer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding-top: 1rem;
`;

export const StyledSkeleton = styled(Skeleton)`
  margin-bottom: 1rem;
`;

export const StyledHeaderSkeleton = styled(Skeleton)`
  height: 180px;

  ${theme.breakpoints.up('sm')} {
    height: 260px;
  }
`;

export const ThirdPartyBox = styled('div')`
  position: absolute;
  z-index: 2;
  top: 10%;
  right: 0;
`;

export const StyledImage = styled('img')``;
